import { useEffect, useCallback, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useOnboarding } from '../store/OnboardingStore';
import { AI_AGENTS_MAP, COMMON_CONSTANTS } from '@nile/components';
import { getTabUrlNew } from '@nile/mangifera/src/Pebbles/TabManager';
import { ONBOARDING_CONFIG } from '../components/AIOnboarding/config/onboardingConfig';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import { MLClient } from '@nile/graphql';
import { GET_AI_FEATURE_ONBOARDING_ENTITY } from '@nile/banyan/src/Graphql/Query/ai';
import AIFeaturesHook from '@nile/components/src/Utils/aiFeaturesHook';

export const AIOnboardingHook = () => {
  const location = useLocation();
  const onboarding = useOnboarding();
  const aiFeatureHook = AIFeaturesHook();

  const tabContext = useContext(TabContext);

  const openTicket = (entityId, AGENT_CONSTANT) => {
    tabContext.openTab({
      module: 'TICKET',
      ticketId: entityId,
      data: {
        ticketId: entityId
      },
      params: `?agentOnboarding=${AGENT_CONSTANT}`
    });
  };

  const openScript = (entityId, AGENT_CONSTANT) => {
    tabContext.openTab({
      module: 'CREATE_SCRIPT',
      data: { title: 'New Script', type: 'onboarding' },
      params: `?agentOnboarding=${AGENT_CONSTANT}`
    });
    // tabContext.openTab({
    //   scriptId: entityId,
    //   module: 'SCRIPT_DETAIL',
    //   data: {
    //     scriptId: entityId
    //   },
    //   params: `?agentOnboarding=${AGENT_CONSTANT}`
    // });
  };

  const openKBArticle = (entityId, AGENT_CONSTANT) => {
    tabContext.openTab({
      module: 'KB_ARTICLE',
      data: {
        id: entityId
      },
      params: `?agentOnboarding=${AGENT_CONSTANT}`
    });
  };

  const openPatch = (entityId, AGENT_CONSTANT, data) => {
    tabContext.openTab({
      module: 'RMM_HOME',
      data: {
        viewId: entityId,
        sort: data?.sort
      },
      url: `/rmm/patch/${entityId}`,
      params: `?agentOnboarding=${AGENT_CONSTANT}`
    });
  };

  const openReports = (entityId, AGENT_CONSTANT) => {
    tabContext.openTab({
      module: 'REPORTS_CHARTS_HOME',
      url: `/profitablity/${entityId}/view`,
      params: `?agentOnboarding=${AGENT_CONSTANT}`
    });
  };

  const openReviewQueue = (AGENT_CONSTANT) => {
    tabContext.openTab({
      module: 'WORKSPACE',
      url: '/monica-ai/review-queue/list',
      params: `?agentOnboarding=${AGENT_CONSTANT}`
    });
  };

  const openTicketDeflection = () => {
    tabContext.openTab({
      module: 'AGENTMARKETPLACE',
      url: '/agent/marketplace/12/ticket-deflector/ai-agent'
    });
  };

  const ENTITY_FUNCTION_MAP = {
    Ticket: openTicket,
    Script: openScript,
    KB_Article: openKBArticle,
    PatchDetail: openPatch,
    Report: openReports,
    [AI_AGENTS_MAP.TICKET_TRIAGE]: openReviewQueue,
    [AI_AGENTS_MAP.TICKET_DEFLECTION]: openTicketDeflection
  };

  // Get current module based on URL
  // const getCurrentModule = useCallback(() => {
  //   const allUrl = getTabUrlNew({ getAllURL: true });
  //   const moduleData = getTabModule(location.pathname, allUrl);
  //   return moduleData?.module;
  // }, [location.pathname]);

  // Helper to remove onboarding param from URL
  const getOnboardingEntity = async (
    constant: string,
    options?: { getAIFeaturesList?: boolean }
  ) => {
    const response = await MLClient.query({
      query: GET_AI_FEATURE_ONBOARDING_ENTITY,
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
      variables: {
        input: {
          constant
        }
      }
    });

    if (response?.data?.getAIFeatureOnboardingEntity) {
      if (options?.getAIFeaturesList) {
        const aiFeaturesData = await aiFeatureHook?.getAIFeaturesData();
        const updatedAgentData = aiFeatureHook.getAIFeatureData(constant);
        console.log(
          'ash:: agentOnboaring done',
          updatedAgentData,
          'constant::',
          constant
        );
        if (updatedAgentData) {
          return response?.data?.getAIFeatureOnboardingEntity;
        }
      }
      return response?.data?.getAIFeatureOnboardingEntity;
    }
    return null;
  };

  const redirectToEntity = ({ entity, entityId, constant, data }) => {
    //entityId optional for scripts
    const redirectBasedOnAgentConstant = ENTITY_FUNCTION_MAP?.[constant];
    if (redirectBasedOnAgentConstant) {
      redirectBasedOnAgentConstant(constant);
    }
    if (entity && constant) {
      const redirectFunction = ENTITY_FUNCTION_MAP?.[entity];
      if (redirectFunction) {
        redirectFunction(entityId, constant, data);
      }
    }
  };

  const disableOnboardingInUrl = useCallback(() => {
    const urlParams = new URLSearchParams(location.search);
    urlParams.delete('onboarding');
    const newUrl = urlParams.toString()
      ? `${location.pathname}?${urlParams.toString()}`
      : location.pathname;
    window.history.replaceState({}, '', newUrl);
  }, [location]);

  const getOnboardingConfig = () => {
    return ONBOARDING_CONFIG[onboarding.data.currentFeature] || null;
  };

  return {
    // Explicitly expose all onboarding store properties
    isActive: onboarding.data.isActive,
    currentStep: onboarding.data.currentStep,
    currentFeature: onboarding.data.currentFeature,
    moduleCompleted: onboarding.data.moduleCompleted,
    // Expose all store methods
    startOnboarding: onboarding.startOnboarding,
    nextStep: onboarding.nextStep,
    prevStep: onboarding.prevStep,
    completeOnboarding: onboarding.completeOnboarding,
    skipOnboarding: onboarding.skipOnboarding,
    getModuleProgress: onboarding.getModuleProgress,

    // currentModule: getCurrentModule(),
    disableOnboardingInUrl,
    //currentModuleProgress: getCurrentModuleProgress(),
    getOnboardingConfig,
    redirectToEntity,
    getOnboardingEntity
  };
};
